import ProfessionalProvider from "../../models/resource-management/professional-provider";

export enum CertificationV2TypeEnum {
  VERBAL_REFERRAL_V2 = "VERBAL_REFERRAL_V2",
  VERBAL_PATIENT_CHART_V2 = "VERBAL_PATIENT_CHART_V2",
  WRITTEN_REFERRAL_V2 = "WRITTEN_REFERRAL_V2",
  WRITTEN_PATIENT_CHART_V2 = "WRITTEN_PATIENT_CHART_V2",
  WRITTEN_IDG_V2 = "WRITTEN_IDG_V2",
}

export enum CertificationStatusEnumV2 {
  YES = "YES",
  NO = "NO",
}

export enum CertificationOrigin {
  REFERRAL = "REFERRAL",
  PATIENT_CHART = "PATIENT_CHART",
}

export class WrittenCertificationV2 {
  id: number;
  certifyingPhysician: string;
  certifyingPhysicianRM: ProfessionalProvider;
  certifyingReceivedDate: string;
  attendingPhysician: string;
  attendingReceivedDate: string;
  narrativeOnFile: boolean;
  origin: CertificationOrigin;
  benefitPeriod: number;
  benefitPeriodId: number;
  fromDate: string;
  toDate: string;
  certifyingObtainedFromQbosId: number;
  certifyingObtainedFromId: number;
  attendingObtainedFromQbosId: number;
  attendingObtainedFromId: number;
  attendingSignature: number;
  certifyingSignature: number;
  type: CertificationV2TypeEnum;
}

export class WrittenCertificationV2WithRM extends WrittenCertificationV2 {
  attendingPhysicianRM: ProfessionalProvider;
}

export interface BenefitPeriod {
  id: number;
  payerId: string;
  benefitPeriod: number;
  startDate: string;
  endDate: string;
  isCurrentBenefitPeriod: boolean;
}

export interface CertificationHistory {
  changeMadeTo: Object;
  previousValueString: string;
  previousValueDate: string;
  createdBy: string;
  createdDatetime: string;
  reasonForChange: string;
}
export class MissingBenefitPeriod {
  benefitPeriodId: number;
  benefitPeriod: number;
  startDate: Date;
  endDate: Date;
  labelText: string;
}

export enum CertificationRerportType {
  PATIENT_CERTIFICATION = "patient_certification",
  PATIENT_CERTIFICATION_VERBAL_REFERRAL = "patient_certification_verbal_referral",
}



// WEBPACK FOOTER //
// ./src/certification/models/cti.ts